export default __webpack_public_path__ + "static/media/token-research@3x.ba2dface.png";